/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class LabProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Lab by ID
	 * @param {String|Number} pLabID - The Lab ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getLabByID(pLabID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pLabID)
			{
				this.pict.log.error('No Lab ID provided.');
				return reject(new Error('No Lab ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`Lab/${pLabID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Lab: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = LabProvider;
module.exports.default_configuration = {};
